<template>
  <div>
    <vxe-grid
      ref="xTable"
      highlight-hover-row
      :data="tableData"
      :height="tableHeight"
      :columns="tableColumns"
      :edit-config="editConfig"
      :footer-method="footerMethod"
      show-footer
      keep-source
      row-id="dispatchOrderCode"
      size="mini"
      resizable
      row-key
      border
      empty-text="没有选择调度订单"
    >
      <template v-slot:toolbar_form>
        <slot name="header"> </slot>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip class="item" effect="dark" content="删除" placement="top">
            <i class="el-icon-delete tool-btn" @click="delRow(row)"></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:originPointName="{}">
        <span>
          {{ originPointName ? originPointName : '' }}
        </span>
      </template>
      <template v-slot:destPointName="{}">
        <span>
          {{ destPointName ? destPointName : '' }}
        </span>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import Math from '@/libs/util.math.js'
import { round } from '@/libs/util.number'
export default {
  props: {
    listData: {
      type: Array,
      default: () => [],
    },
    originPointName: {
      type: String,
      default: '',
    },
    destPointName: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  components: {},
  data() {
    return {
      editConfig: {
        enabled: true,
        trigger: 'click',
        mode: 'cell',
        showStatus: true,
      },
      params: {},
      tableHeight: 180,
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
      },
      tableData: this.listData,
      tableColumns: [
        {
          field: 'seq',
          width: 40,
          align: 'center',
          fixed: 'left',
          type: 'seq',
        },
        {
          field: 'col-opt',
          title: '操作',
          headerAlign: 'center',
          align: 'center',
          fixed: 'left',
          width: 50,
          slots: {
            default: 'opt',
          },
        },
        {
          title: '调度订单编号',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          headerAlign: 'center',
          fixed: 'left',
          align: 'left',
          width: 140,
          field: 'dispatchOrderNo',
        },
        {
          field: 'orderNo',
          title: '原订单编号',
          align: 'center',
          width: 150,
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          title: 'ERP/WMS单号',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          headerAlign: 'center',
          align: 'left',
          width: 120,
          field: 'bizBillNo',
        },
        {
          field: 'totQty',
          title: '件数',
          headerAlign: 'center',
          align: 'center',
          width: 60,
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          field: 'totPayWeight',
          title: '支出重量',
          headerAlign: 'center',
          align: 'center',
          width: 90,
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          field: 'totPayVolume',
          title: '支出体积',
          headerAlign: 'center',
          align: 'center',
          width: 90,
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          field: 'totValue',
          title: '总货值',
          headerAlign: 'center',
          align: 'center',
          width: 100,
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          title: '支出运费',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          headerAlign: 'center',
          align: 'center',
          width: 100,
          field: 'payFreight',
          editRender: {
            name: 'input',
            attrs: { type: 'number' },
          },
        },
        {
          title: '支出费用',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          headerAlign: 'center',
          align: 'center',
          width: 100,
          field: 'payFee',
          editRender: {
            name: 'input',
            attrs: { type: 'number' },
          },
        },
        {
          title: '支出总价',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          headerAlign: 'center',
          align: 'center',
          width: 100,
          field: 'payAmount',
          editRender: {
            name: 'input',
            attrs: { type: 'number' },
          },
        },
        {
          title: '合同运费',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          headerAlign: 'center',
          align: 'center',
          width: 100,
          field: 'contractFreight',
        },
        {
          title: '合同费用',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          headerAlign: 'center',
          align: 'center',
          width: 100,
          field: 'contractFee',
        },
        {
          title: '合同总价',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          headerAlign: 'center',
          align: 'center',
          width: 100,
          field: 'contractAmount',
        },
        {
          title: '发货方',
          showHeaderOverflow: 'title',
          showOverflow: 'tooltip',
          headerAlign: 'center',
          align: 'center',
          width: 150,
          field: 'originPointName',
          slots: {
            default: 'originPointName',
          },
        },
        {
          field: 'pickupProvinceName',
          title: '发货省份',
          headerAlign: 'center',
          align: 'left',
          width: 100,
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          field: 'pickupCityName',
          title: '发货城市',
          headerAlign: 'center',
          align: 'left',
          width: 100,
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          field: 'pickupDistrictName',
          title: '发货区县',
          headerAlign: 'center',
          align: 'left',
          width: 100,
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          title: '收货方',
          showHeaderOverflow: 'title',
          showOverflow: 'tooltip',
          headerAlign: 'center',
          align: 'center',
          width: 150,
          field: 'destPointName',
          slots: {
            default: 'destPointName',
          },
        },
        {
          field: 'receiveProvinceName',
          title: '收货省份',
          headerAlign: 'center',
          align: 'left',
          width: 100,
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          field: 'receiveCityName',
          title: '收货城市',
          headerAlign: 'center',
          align: 'left',
          width: 100,
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          field: 'receiveDistrictName',
          title: '收货区县',
          headerAlign: 'center',
          align: 'left',
          width: 100,
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
      ],
      totalInfo: {
        payFreight: 0,
        payFee: 0,
        payAmount: 0,
        contractFreight: 0,
        contractFee: 0,
        contractAmount: 0,
      },
    }
  },
  watch: {
    listData: {
      handler(listData) {
        this.tableData = listData
      },
    },
  },
  computed: {
    xTable() {
      return this.$refs.xTable
    },
  },
  methods: {
    updateData() {
      this.xTable.updateData()
    },
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 1) {
            return '合计'
          }
          if (
            [
              'payFreight',
              'payFee',
              'payAmount',
              'contractFreight',
              'contractFee',
              'contractAmount',
            ].includes(column.property)
          ) {
            const result = this.sumNum(data, column.property)
            this.totalInfo[column.property] = result
            return result
          }

          return null
        }),
      ]
    },
    sumNum(list, field) {
      if (!list) return 0
      const sum = list
        .map((t) => t[field])
        .reduce((total, next) =>
          Math.number(
            Math.add(Math.bignumber(total || 0), Math.bignumber(next || 0))
          )
        )
      return round(sum, 4)
    },
    delRow(row) {
      this.$confirm('您确定要移除该调度订单吗?').then((type) => {
        if (type === 'confirm') {
          let index = this.$refs.xTable.getRowIndex(row)
          this.tableData.splice(index, 1)
        }
      })
    },
    getTableData() {
      const ds = this.$refs.xTable.getData()
      return ds
    },
  },
}
</script>
